import React, { useContext, FC, useState } from 'react';
import { Link } from 'react-router-dom';
import { Dropdown, Menu, Avatar, Button, Space } from 'antd';
import {
  FaUserAlt,
  // FaUserCircle
} from 'react-icons/fa';
import { AiOutlineBars } from 'react-icons/ai';
import { RiLogoutBoxLine } from 'react-icons/ri';
import { IoIosArrowDown } from 'react-icons/io';
import { ToogleLinkButton } from 'app/components/ToogleLinkButton/ToogleLinkButton';
import { BUTTON } from 'app/components/ToogleLinkButton/models.d';
import { UserFragmentProps } from '../models';
import { WSUserContext } from 'app/contexts/UserContext/UserContext';

import './UserProfile.scss';

const UserProfile: FC<UserFragmentProps> = ({ variant = 'navbar' }) => {
  const user = useContext(WSUserContext);

  const [isVisible, setIsVisible] = useState(false);

  const widgetMenuNavbar = (
    <Menu className="user-menu">
      {/* <Menu.Item className="user-menu__item">
        <Link to="/dashboard">
          <FaUserCircle className="user-menu__icon" />
          Dashboard
        </Link>
      </Menu.Item> */}
      <Menu.Item className="user-menu__item">
        <Link to="/account-settings">
          <AiOutlineBars className="user-menu__icon" />
          Manage Account
        </Link>
      </Menu.Item>
      <Menu.Item className="user-menu__item" onClick={() => user.logout?.()}>
        <RiLogoutBoxLine className="user-menu__icon" />
        Sign Out
      </Menu.Item>
    </Menu>
  );

  const userNavbar = (
    <div className="user-priofile user-priofile--navbar">
      <Dropdown
        overlay={widgetMenuNavbar}
        placement="bottom"
        visible={isVisible}
        onVisibleChange={isVisible => {
          !isVisible && setIsVisible(isVisible);
        }}
      >
        <Button onClick={e => setIsVisible(true)}>
          <Space>
            <Avatar
              icon={
                <>
                  <FaUserAlt className="user-icon" />
                </>
              }
            />
            <IoIosArrowDown className="arrow-down" />
          </Space>
        </Button>
      </Dropdown>
    </div>
  );

  const userSidebar = (
    <div className="user-priofile user-priofile--sidebar">
      <ToogleLinkButton
        onClick={() => user.logout?.()}
        variant={BUTTON.VARIANT.TEXT}
        size={BUTTON.SIZE.MEDIUM}
        className="user-priofile__sign-out--sidebar"
        AppendChild={<RiLogoutBoxLine />}
      >
        Sign Out
      </ToogleLinkButton>
      {/* <ToogleLinkButton
        link="/dashboard"
        variant={BUTTON.VARIANT.TEXT}
        size={BUTTON.SIZE.SMALL}
        className="user-priofile__btn--sidebar"
        PrependChild={<FaUserCircle />}
      >
        Dashboard
      </ToogleLinkButton> */}
      <ToogleLinkButton
        link="/account-settings"
        variant={BUTTON.VARIANT.TEXT}
        version={BUTTON.VERSION.INTERNAL_LINK}
        size={BUTTON.SIZE.SMALL}
        className="user-priofile__btn--sidebar"
        PrependChild={<AiOutlineBars />}
      >
        Manage Account
      </ToogleLinkButton>
    </div>
  );

  return variant === 'navbar' ? userNavbar : userSidebar;
};

export default UserProfile;
